module.exports = __webpack_public_path__ + "img/arrow-bottom.054eeb35_054eeb35f3c09dbf6ffdfb7a6ec4e5bd.054eeb35.svg";